import { ReactElement } from 'react';
import { StockManagement } from '@mapado/seating';
import EventDatePagesHeader from '../components/EventDatePagesHeader';
import useQueryNumberParam from '../useQueryNumberParam';

export default function DemoStockManagement(): ReactElement {
  const eventDateId = useQueryNumberParam('eventDateId', 262104);

  return (
    <>
      <EventDatePagesHeader
        title="Gestion des stocks (contingents, catégorie, jauge)"
        eventDateId={eventDateId}
      />

      <StockManagement
        eventDateId={eventDateId}
        onStockChanged={() => {
          // eslint-disable-next-line no-console
          console.log('Stock changed');
        }}
      />
    </>
  );
}
